'use client';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";
import Container from "../core/container";
import Section from "../core/section";
import { Heading, StylizedHeading } from "../core/heading";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger);

interface Props {
    page_title: string,
    title: string,
    subtitle?: string,
}

export default function PageHero(props: Props) {

    const tl = useRef<gsap.core.Timeline>(null);
    const container = useRef<HTMLDivElement>(null);

    useGSAP(() => {
        tl.current = gsap.timeline();

        tl.current.fromTo(
            container.current!.children,
            {
                autoAlpha: 0,
                y: 200,
            },
            {
                autoAlpha: 1,
                y: 0,
                stagger: 0.1,
                ease: "power3.out",
                duration: 0.8,
            },
        );

    }, { scope: container, dependencies: [] });

    return (
        <Section>
            <Container
                ref={container}
                className="hero-container flex flex-col justify-center py-32 space-y-4"
            >
                <>
                    <StylizedHeading as="h1" content={props.page_title} />
                    <div className="max-w-screen-lg pr-2 sm:pr-0">
                        <Heading
                            size="10xl"
                            transform="uppercase"
                            content={props.title}
                        />
                    </div>
                    {props.subtitle && (
                        <Heading
                            size="5xl"
                            weight="normal"
                            content={props.subtitle}
                            className="text-5xl"
                        />
                    )}
                </>
            </Container>
            <style>{`
                .hero-container > * {
                    opacity: 0;
                    visibility: hidden;
                }
            `}</style>
        </Section>
    );
}